"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "FormItem",
  emits: ['updateModelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Number | String | Date | Boolean | Array | Object,
    item: {
      type: Object,
      default: function _default() {
        // { label: '名称', prop: 'apply_type', defaultValue: '', type: 'select', options: {} },
        // item.type: input | select | store-select | mechanism-select | remote-select | date | dateRange | datetimeRange
        return {};
      }
    }
  },
  computed: {
    value: {
      get: function get() {
        return this.modelValue;
      },
      set: function set(val) {
        this.$emit('update:modelValue', val);
        return val;
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      storeList: [],
      remoteList: []
    };
  },
  watch: {},
  methods: {
    getRemoteList: function getRemoteList(value) {
      var _this = this;
      if (value) {
        var item = this.item;
        if (item.options && item.options.remoteMethod) {
          this.loading = true;
          item.options.remoteMethod(value).then(function (list) {
            _this.remoteList = list || [];
          }).catch(function (err) {
            _this.remoteList = [];
          }).finally(function () {
            _this.loading = false;
          });
        } else {
          this.remoteList = [];
        }
      } else {
        this.remoteList = [];
      }
    }
  }
};